/* src/app/modules_v2/finance/credit-policy/components/credit-policy-operation-dialog/credit-policy-operation-dialog.component.scss */
.cpo-header-text {
  min-width: 0;
  padding-right: 36px;
}
.cpo-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 16px;
}
.cpo-grid__wide {
  grid-column: span 2;
}
.cpo-section {
  margin-top: 8px;
}
.cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.cpo-link {
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  color: #4d7a00;
  cursor: pointer;
}
.cpo-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow: auto;
}
.cpo-item {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 12px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  font-size: 13px;
}
.cpo-item--editing {
  background: #fbfee8;
  border-color: #c5d94a;
}
.cpo-item__date {
  color: #6b7280;
  white-space: nowrap;
}
.cpo-item__main {
  min-width: 0;
}
.cpo-item__text {
  font-weight: 600;
  color: #1a1d23;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cpo-item__meta {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cpo-item__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cpo-item__actions {
  display: flex;
  align-items: center;
}
.cpo-item__btn {
  width: 34px !important;
  height: 34px !important;
  padding: 5px !important;
  color: #6b7280;
}
.cpo-item__btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cpo-item__btn--danger {
  color: #dc2626;
}
.cpo-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.cpo-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cpo-empty--error {
  color: #dc2626;
  border-color: #fecaca;
  background: #fef2f2;
}
@media (max-width: 720px) {
  .cpo-grid {
    grid-template-columns: 1fr;
  }
  .cpo-grid__wide {
    grid-column: auto;
  }
  .cpo-item {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .cpo-item__date {
    grid-column: 1/-1;
    font-size: 12px;
  }
}
/*# sourceMappingURL=credit-policy-operation-dialog.component.css.map */
